/* Template: Donation Landing Page
 ========================================================================== */

template.donation_option = function() {
    'use strict';

    var _donationTypeContainers = $('.donation-type');
    $(_donationTypeContainers).hide();

    var _donationTypeRadios = $('.donation-types input[type=radio]');

    _donationTypeRadios.on('ifChanged change', function(){
        if (!this.checked) { return; }

        var _container = '.donation-'+$(this).attr('value');
        var _label = $('label[for="'+$(this).attr('id')+'"]');

        $(_donationTypeContainers).hide();
        $(_container).show();

        $('.donation-types label').removeClass('active');
        _label.addClass('active');

    });

    _donationTypeRadios.each(function(){
        if( $(this).is(':checked') ){
            var _container = '.donation-'+$(this).attr('value');
            var _label = $('label[for="'+$(this).attr('id')+'"]');

            $(_donationTypeContainers).hide();
            $(_container).show();

            $('.donation-types label').removeClass('active');
            _label.addClass('active');
        }
    });

};